import Header from "./Header";
import Main from "./Main";
import SideLeft from "./SideLeft";
import SideRight from "./SideRight";
import TransactionsNavigation from "./TransactionsNavigation";
import ThumbnailSelectorModal from "./UI/Modals/ThumbnailSelector";
import TDPPipelineStatusModal from "./shared/TDPPipelineStatusModal";
import DocModalUpload from "./shared/DocModalUpload";
import CDAUploadModal from "./shared/CDAUploadModal";
import Preview from "./Main/Docs/Preview";
import ImportModal from "./Main/Details/ImportModal";

const App = () => (
  <>
    <Preview />
    <DocModalUpload />
    <CDAUploadModal />
    <div className="tw-h-full tw-overflow-auto" id="tdp-app">
      <div className="tw-min-w-[1336px] tw-p-24px">
        <TransactionsNavigation />
        <Header />
        <div className="tw-flex tw-flex-nowrap tw-gap-x-16px">
          <SideLeft />
          <Main />
          <SideRight />
        </div>
        <ThumbnailSelectorModal />
        <TDPPipelineStatusModal />
        <ImportModal />
      </div>
    </div>
  </>
);

export default App;
